<script>
    import { createEventDispatcher } from 'svelte';
    import OPTS from '../options';

    export let total = 0;
    export let perpage = 16;
    export let show = 7;
    export let current_page = 1;

    $: num_pages = Math.ceil(total / perpage);
    $: break_point = Math.floor(show / 2)

    // una finestra sui numeri di pagine da mostrare che si sposta quando si cambia pagina
    let page_window;
    $: {
        if (num_pages <= show) {
            page_window = range(1, num_pages);
        } else {
            let start = Math.max(current_page - break_point, 1);
            let end = Math.min(Math.max(current_page + break_point, show), num_pages);
            let diff = show - (end - start + 1);

            page_window = range(start - diff, end);
        }
    }

    const dispatch = createEventDispatcher();

    function range(start, end) {
        return Array.from({length: ((end + 1) - start)}, (v, k) => k + start);
    }

    function changePage(num) {
        dispatch("change-page", { page: num })
    }
</script>

<nav aria-label="Page navigation example">
    <ul class="pagination justify-content-center">
        {#if total > 0}
            <!-- precedente -->
            <li class="page-item" class:disabled={current_page === 1}>
                <a on:click|preventDefault={() => changePage(current_page - 1)} class="page-link" href="#" tabindex="-1"><img src="{`${OPTS.base_url}img/arrow.svg`}">precedente</a>
            </li>

            <!-- pagine -->
            {#each page_window as page}
                <li class="page-item" class:disabled={current_page === page}>
                    <a on:click|preventDefault={() => changePage(page)} class="page-link" href="#">{page}</a>
                </li>
            {/each}

            <!-- successivo -->
            <li class="page-item" class:disabled={current_page === num_pages}>
                <a on:click|preventDefault={() => changePage(current_page + 1)} class="page-link" href="#">successiva<img src="{`${OPTS.base_url}img/arrow.svg`}"></a>
            </li>
        {/if}
    </ul>
</nav>
